import { ofType, combineEpics } from "redux-observable";
import { concat, Observable, of } from "rxjs";
import { map, switchMap, startWith, filter } from "rxjs/operators";
import { responseFrom, ResponseAction, request } from "../../ajax";
import { Action as TAction } from "../../Store";
import { ErrorResponse } from "../../utils";
import { Actions } from "./state/actions";
import { State } from "./state/state";

// These epic patterns described by react-observable maintainer here:
// https://stackoverflow.com/questions/48261438/composing-and-sequencing-multiple-epics-in-redux-observable/48307271#48307271
// This allows to run through ajax reducers.
// TODO - replace the switchMap pipe with a pipable operator so we can reuse this pattern
export const getEpic = (action$: Observable<TAction>): Observable<TAction> =>
  action$.pipe(
    ofType(Actions.REQUEST_GET),
    switchMap(() =>
      action$.pipe(
        responseFrom("/ATX/timers/rtc"),
        map((a: ResponseAction<State.ServerResponse>) =>
          Actions.getResponse({ data: a.data })
        ),
        startWith(request("/ATX/timers/rtc"))
      )
    )
  );

export const postEpic = (action$: Observable<TAction>): Observable<TAction> =>
  action$.pipe(
    ofType(Actions.REQUEST_POST),
    filter((a: Actions.PostRequest) => !!Object.keys(a.data).length),
    switchMap((req: Actions.PostRequest) =>
      action$.pipe(
        responseFrom("/ATX/timers/rtc/comp", "POST"),
        switchMap((a: ResponseAction<ErrorResponse>) =>
          concat(
            of(Actions.postResponse({ data: a.data })),
            of(Actions.getRequest()),
            of(request("/ATX/exe/save", { save: 1 }))
          )
        ),
        startWith(request("/ATX/timers/rtc/comp", req.data))
      )
    )
  );

export default combineEpics(getEpic, postEpic);
